/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { AsyncResult } from '@msdyn365-commerce/core';

import { observer } from 'mobx-react';
import * as React from 'react';
import Table from 'reactstrap/lib/Table';

import { ISmweSkuSelectorContainerData } from './smwe-sku-selector-container.data';
import { ISmweSkuSelectorContainerProps } from './smwe-sku-selector-container.props.autogenerated';

/**
 *
 * SmweSkuSelectorContainer component
 * @extends {React.Component<ISmweSkuSelectorContainerProps<ISmweSkuSelectorContainerData>>}
 */
@observer
class SmweSkuSelectorContainer extends React.Component<ISmweSkuSelectorContainerProps<ISmweSkuSelectorContainerData>> {

    /*
    constructor(props: ISmweSkuSelectorContainerProps<ISmweSkuSelectorContainerData>) {
        super(props);
    }
    */

    private readonly attributeName: string = 'Can add to cart';

    // --------------------------------------------------------------
    // --------------------------------------------------------------
    public render(): JSX.Element | null {
        console.log('RenderModule');
        const { slots, data } = this.props;

        // Based on the current product, we might not want to show the SKU Selector
        const attributeList = data && data.productSpecificationData && data.productSpecificationData.result;
        const canAddToCartAttribute = attributeList && attributeList.filter(
            attribute => attribute.Name! === this.attributeName
        );
        const show = (canAddToCartAttribute && canAddToCartAttribute.length) ? canAddToCartAttribute[0].BooleanValue : true;

        if (!slots || !show) {
            return null;
        }

        // @ts-ignore
        const tableClass: AsyncResult<string> = this.props.context.actionContext.get('String', 'Generic-SkuSelectorClasses');

        // sku fields we are interested in
        const children = [
            {
                heading: 'Product',
                cellClass: 'sku-selector-product-title',
                slot: 'productTitle',
            },
            {
                heading: 'Price',
                cellClass: 'sku-selector-product-price',
                slot: 'productPrice',
            },
            {
                heading: 'Club',
                cellClass: 'sku-selector-product-price',
                slot: 'productClubPrice',
            },
            {
                heading: 'QTY',
                cellClass: 'sku-selector-product-quantity',
                slot: 'productQuantity',
            },
            {
                heading: '',
                cellClass: 'sku-selector-add-to-cart',
                slot: 'productAddToCart',
            }
        ];

        return (
            <div className={`sku-selector-container row ${tableClass && tableClass.result}`}>
                <Table borderless responsive size='lg' role='presentation'>
                    <thead>
                        <tr>
                            {children.map((entry, index: number) => {
                                if (slots[entry.slot] && slots[entry.slot].length) {
                                    return (
                                        <th scope='col' className={entry.cellClass} key={index}>
                                            {entry.heading}
                                        </th>
                                    );
                                }

                                return null;
                            })}
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            {children.map((entry, index: number) => {
                                if (slots[entry.slot] && slots[entry.slot].length) {
                                    return (
                                        <td scope='col' className={entry.cellClass} key={index}>{slots[entry.slot][0]}</td>
                                    );
                                }

                                return null;
                            })}
                        </tr>
                    </tbody>
                </Table>
            </div>
        );
    }
}

export default SmweSkuSelectorContainer;
